import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import '../interactions/interactions';
import css from './control-collapse.css';

const ControlCollapse = ({
  ariaLabel,
  disabled,
  disc,
  handleClick,
  ...otherProps
}) => (
  <button
    className={classnames(css['ds-control-collapse'], {
      [css['ds-control-collapse--disc']]: disc,
    })}
    onClick={handleClick}
    aria-label={ariaLabel}
    disabled={disabled}
    type='button'
    {...otherProps}
  >
    <svg viewBox='5 5 14 14' xmlns='http://www.w3.org/2000/svg'>
      <path
        className={classnames(css['path-background'], {
          [css['path-background--disabled']]: disabled,
        })}
        d='M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z'
      />
    </svg>
  </button>
);

ControlCollapse.defaultProps = {
  ariaLabel: 'Collapse',
  disabled: false,
  disc: false,
  handleClick: null,
};

ControlCollapse.propTypes = {
  ariaLabel: PropTypes.string,
  disabled: PropTypes.bool,
  disc: PropTypes.bool,
  handleClick: PropTypes.func,
};

export default ControlCollapse;
